import { isDefined } from "@clipboard-health/util-ts";
import { formatISO, parseISO } from "date-fns";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time
import { formatInTimeZone } from "date-fns-tz";
import { groupBy } from "lodash";

import { type OpenShiftListItem, type OpenShiftWorkplace, type TimeSlot } from "../types";
import { buildVirtualShiftListGroup } from "./buildVirtualShiftListGroup";
import type { VirtualShiftListGroup } from "./types";

export const getVirtualShiftListItemDateIso = (start: string, timezone?: string): string => {
  const date = parseISO(start);

  if (isDefined(timezone)) {
    return formatInTimeZone(date, timezone, "yyyy-MM-dd");
  }

  return formatISO(date, { representation: "date" }); // yyyy-MM-dd
};

export function getVirtualShiftListGroupsMap({
  shifts,
  workplacesMap,
  visibleTimeSlots,
}: {
  shifts: OpenShiftListItem[];
  workplacesMap: Map<string, OpenShiftWorkplace>;
  visibleTimeSlots: TimeSlot[];
}) {
  const shiftListGroupByDate = new Map<string, VirtualShiftListGroup>();

  const shiftsByDate = groupBy(shifts, (shift) => {
    // This should eventually be for any shift list injection item not just in-app-ads
    // injected items do not have a workplace or timezone
    if (
      shift.type === "in-app-ad" ||
      shift.type === "fortune-cookie" ||
      shift.type === "worker-pay-survey"
    ) {
      return getVirtualShiftListItemDateIso(shift.start ?? "");
    }

    const workplace = workplacesMap.get(shift.relationships.workplace.data.id);
    return getVirtualShiftListItemDateIso(
      shift.attributes.start,
      workplace?.attributes.location.timezone
    );
  });

  Object.entries(shiftsByDate).forEach(([dateIso, shiftsForDate]) => {
    const shiftGroup = buildVirtualShiftListGroup({
      dateIso,
      shiftsForDate,
      visibleTimeSlots,
    });

    shiftListGroupByDate.set(dateIso, shiftGroup);
  });

  return shiftListGroupByDate;
}
